import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * CardIconTile
 *
 * The rounded icon square in a dashboard card's corner. Not a pill, despite what it used to be
 * called: it carries an icon rather than a word, and nothing about it says status. See
 * docs/dev/pills.md for the things that are pills.
 * 
 * Props:
 *  - icon: Bootstrap icon class (e.g., "bi-rocket-takeoff-fill")
 *  - variant: 'purple' | 'green' | 'primary' | 'teal' | 'muted'
 *  - size: 'sm' | 'md' | 'lg' (default: 'md')
 *  - className: Additional CSS classes
 */
export default function CardIconTile({
  icon,
  variant = 'primary',
  size = 'md',
  className = '',
}) {
  const badgeClasses = classNames(
    'card-icon-tile',
    `card-icon-tile-${variant}`,
    `card-icon-tile-${size}`,
    className
  );

  return (
    <span className={badgeClasses}>
      <i className={`bi ${icon}`} />
    </span>
  );
}

CardIconTile.propTypes = {
  icon: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['purple', 'green', 'primary', 'teal', 'muted']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
};
